import { styled } from '@mui/material/styles';

export const StyledOrderedList = styled('ol')({
  padding: 0,
  margin: 0,
});
